module.exports = __webpack_public_path__ + "img/snowflake-satek-1.9dd40a38.png";